var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"team"},[_c('div',{staticClass:"flag"},[(_vm.team.code)?_c('country-flag',{attrs:{"country":_vm.team.code,"size":"normal"}}):_vm._e()],1),_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.team.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }